//import get_chat_socket from "@/pcomponents/common/content/chat/socket";
import { io } from "socket.io-client";
function get_chat_socket() {
  let cors_opt: any = {
    cors: {
      origin: "*",
    },
    secure: true
  };
  const socket = io(process.env.REACT_APP_Chat_SERVER_URL as string, cors_opt);
  return socket;
};

export default get_chat_socket;